export const FEEDBACK_ERROR = "FEEDBACK_ERROR";
export const FEEDBACK_INFO = "FEEDBACK_INFO";
export const FEEDBACK_SUCCESS = "FEEDBACK_SUCCESS";
export const FEEDBACK_WARNING = "FEEDBACK_WARNING";

export const MY_POKEMONS_ADD = "MY_POKEMONS_ADD";
export const MY_POKEMONS_REMOVE = "MY_POKEMONS_REMOVE";

export const POKEMONS_GET = "POKEMONS_GET";
export const POKEMONS_GET_DETAILS = "POKEMONS_GET_DETAILS";
export const POKEMONS_LOADING = "POKEMONS_LOADING";
